module.exports = __webpack_public_path__ + "static/media/core2.e146011f.jpeg";